<template>
    <div style="display: flex; height: 100%; ">
        <v-row style="margin: 0px; height: 80%; align-self: center;">
            <v-col class="tableau">
                <v-data-table style="height: 100%;" :items="onduleurs" :headers="headerOnduleurs" :items-per-page="-1"
                    fixed-header hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_onduleurs_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click="deleteItem(item)">
                            mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
            <v-col class="formulaire">
                <!-- <v-btn @click="this.openModal" class="ajoutModeleBouton">
                    <div>{{ $t("_je_ne_trouve_pas_mon_onduleur_") }}</div>
                </v-btn> -->
                <div class="questions">
                    <div class="champs">
                        <div>
                            {{ $t("_modele_") }} (*)
                        </div>
                        <div class="inputField" :style="{ marginTop: '5px' }">
                            <v-autocomplete
                                v-model="reponse.modele.value"
                                :items="filteredListeOnduleur"
                                :search-input.sync="searchModele" 
                                item-text="data.key"
                                :return-object="true" color="orange"
                                outlined
                                no-filter
                                clearable
                                :multiple="false" >
                            </v-autocomplete>
                            </div>
                    </div>
                        <div v-if="reponse.modele.value && reponse.modele.value.data && 
                               (reponse.modele.value.data.mppt_nb === undefined || reponse.modele.value.data.mppt_nb === null)">
                        
                        <v-label>{{ $t("_nb_de_mppt_") }} (*)</v-label>
                        <v-text-field color="orange" outlined class="inputField" v-model="nbMppt"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></v-text-field>
                    </div>
                    <v-btn :disabled="!rempli"
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="addData()">
                        {{ $t("_ajouter_") }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <PopUpAjouterModele v-if="this.modalAjout" :type="'onduleur'" @saveModel="save" @close="modalAjout = false">
            <template v-slot:title>
                {{ $t("_ajouter_un_nouvel_onduleur_a_la_liste_") }}
            </template>
        </PopUpAjouterModele>
    </div>
</template>

<script>
import api from "@/api/api";
import PopUpAjouterModele from "./PopUpAjouterModele.vue";


export default {
    props: {
        initOnduleurs: {
            required: false,
        },
        install_id: {
            required: true
        },
        initHistorique: {
            required: false
        },
        initCalepinage: {
            required: false
        }
    },

    components: {
        PopUpAjouterModele,
    },

    async mounted() {
        console.log("init onduleur", this.initOnduleurs)
        if (this.initOnduleurs !== undefined && this.initOnduleurs !== null )
            this.onduleurs = this.initOnduleurs

        this.listeOnduleur = await api.get_inv_model()
        try {
            const reponse = (await api.get_models_inverters(this.install_id)).data

            reponse.forEach(element => {
                this.listeOnduleur.push(element)
            });
        }
        catch {
            console.log("pas d'onduleur ajouté")
        }
        if (this.initHistorique !== undefined && this.initHistorique !== null)
            this.historique = this.initHistorique
        if (this.initCalepinage !== undefined && this.initCalepinage !== null)
            this.calepinage = this.initCalepinage
    },

    data() {
        return {
            historique: [],
            calepinage: [],
            onduleurs: [],
            listeOnduleur: [],
            headerOnduleurs: [
                { key: 'modele', text: this.$t('_modele_'), value: 'modele' },
                { key: 'nb_mppt', text: this.$t('_nb_de_mppt_'), value: 'nb_mppt' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            reponse: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "modele": {
                    "value": "",
                    "required": true,
                },
            },
            reponseVide: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "modele": {
                    "value": "",
                    "required": true,
                },
            },
            modalAjout: false,
            nbMppt: null,
            searchModele: null,
        }
    },

    computed: {
        filteredListeOnduleur() {
            if (!this.searchModele) {
                return this.listeOnduleur;
            }
            const searchLower = this.searchModele.toLowerCase();
            return this.listeOnduleur.filter(modele => {
                const key = modele.data.key ? modele.data.key.toLowerCase() : '';
                return key.includes(searchLower); 
            });
        },

        rempli() {
            const selectedModele = this.reponse.modele.value;
            if (!selectedModele || typeof selectedModele !== 'object' || !selectedModele.data) {
                console.log("test");
                return false;
            }

            const mpptNbFromModel = selectedModele.data.mppt_nb;

            if (mpptNbFromModel === undefined || mpptNbFromModel === null) {
                if (this.nbMppt === null || this.nbMppt === undefined || this.nbMppt === '') {
                    return false;
                }
            }
            return true;
        }
    },

    methods: {
        // ... (votre fonction addData reste inchangée, elle fonctionnera maintenant) ...
        addData() {
            if (!this.rempli) {
                return;
            }
            
            const selectedModele = this.reponse["modele"].value;
            if (!selectedModele || !selectedModele.data || !selectedModele.data.key) {
                 console.error("Modèle sélectionné invalide ou incomplet.");
                 return;
            }

            let justeValeurs = { 
                ...selectedModele.data,
                id: this.onduleurs.length + 1,
                modele: selectedModele.data.key,
            };

            const mpptNbFromModel = selectedModele.data.mppt_nb;
            if (mpptNbFromModel === undefined || mpptNbFromModel === null) {
                justeValeurs["nb_mppt"] = this.nbMppt;
            } else {
                justeValeurs["nb_mppt"] = mpptNbFromModel;
            }

            this.onduleurs.push(justeValeurs)
            this.$nextTick(() => {
                this.reponse = Object.assign({}, this.reponseVide);
                this.searchModele = null;
                this.nbMppt = null;
            })
            
            this.$emit("answer", { "reponse": this.onduleurs, "historique": this.historique, "calepinage": this.calepinage })
        },

        deleteItem(item) {
            let newHistorique = []
            let newCalepinage = []
            let diff = 0
            this.historique.forEach(inv => {
                if (inv.type !== item.modele) {
                    newHistorique.push(inv)
                }
                else {
                    let tempCalepinage = []
                    this.calepinage.forEach(calp => {
                        if (calp.idOnduleur !== inv.id-diff) {
                            if (calp.idOnduleur > inv.id)
                                calp.idOnduleur -= 1
                            tempCalepinage.push(calp)
                        }
                    })
                    newCalepinage = tempCalepinage
                    diff +=1
                }
            })
            for (var i = 0; i < newCalepinage.length; i += 1) {
                newCalepinage[i].id = i + 1
            }
            for (var j = 0; j < newHistorique.length; j += 1) {
                newHistorique[j].id = j + 1
            }
            this.historique = newHistorique
            this.calepinage = newCalepinage

            this.onduleurs.splice(this.onduleurs.indexOf(item), 1)
            this.$nextTick(() => {
                for (var i = 0; i < this.onduleurs.length; i += 1) {
                    this.onduleurs[i].id = i + 1
                }
            })
            this.$emit("answer", { "reponse": this.onduleurs, "historique": this.historique, "calepinage": this.calepinage })
        },
        openModal() {
            this.modalAjout = true
        },
        save(modele) {
            this.modalAjout = false
            this.listeOnduleur.unshift(modele)
            api.post_model_inverter(this.install_id, modele)
        }
    },
    watch: {
        onduleurs: {
            handler() {
                if (this.onduleurs.length > 0) {
                    this.$emit('enable')
                }
                else {
                    this.$emit('disable')
                }
            },
            deep: true
        },
        initOnduleurs: {
            handler() {
                if (this.initOnduleurs !== undefined && this.initOnduleurs !== null)
                    this.onduleurs = this.initOnduleurs
            }
        }
    }
}
</script>

<style scoped>
.tableau {
    align-content: center;
    height: 100%;
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.v-btn__content {
    -webkit-box-align: center;
    color: inherit;
    -webkit-box-flex: 1;
    -webkit-box-pack: inherit;
    line-height: normal;
    position: relative;
    transition-property: opacity;
    flex: 0 auto;
}

.formulaire {
    position: relative;
}


.v-messages {
    min-height: 0;
    height: 0;
}


.unit {
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}

.questions {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    padding: 10px;
    min-width: 70%;
}

.ajoutModeleBouton {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    background-color: #d9d9d9;
    font-size: medium;
}
</style>